import React, { useContext, useEffect, useState } from "react";
import { apiDelete, apiPost, apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { AiFillDelete, AiFillEdit, AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort, BsHandThumbsUp } from "react-icons/bs";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { Link, NavLink } from "react-router-dom";
import OButton from "components/reusable/OButton";
import OInputField from "components/reusable/OInputField";
import { useForm } from "react-hook-form";
import OImage from "components/reusable/OImage";
import { TextField } from "@mui/material";

const List = ({
  page,
  sort,
  setSort,
  list,
  fetchProperties,
  manager,
  paginationObj,
}) => {
  const { t } = useTranslation();
  const { user, config } = useContext(AuthContext);
  const notification = useToastContext();
  const [selectedProperty, setSelectedProperty] = useState([]);
  const [selectedPropertyAgent, setSelectedPropertyAgent] = useState([]);
  const [showAddModal, setAddModal] = useState(false);
  const [selctAllCheck, setSelectAllCheck] = useState(false);
  const [presentationUrl, setPresentationUrl] = useState(false);
  const [changeAgentModal, setChangeAgentModal] = useState(false);
  const [profilePic, setProfilePic] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });

  const handelSoldChange = async (item) => {
    try {
      const payload = {
        isSold: item?.isSold ? false : true,
      };
      const path = `${apiPath.ChangeSoldStatusProperties}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        fetchProperties();
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.ChangeStatusProperties}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        fetchProperties();
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  const deleteProperty = async (item) => {
    try {
      const path = `${apiPath.Properties}/${item?._id}`;
      const result = await apiDelete(path);
      if (result?.status === 200) {
        notification.success(result.data.message);
        fetchProperties();
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  const handelFeatureStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.isFeatured === false,
      };
      const path = `${apiPath.propertyFeature}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        fetchProperties();
      }
    } catch (error) {
      console.log("error in get all sub admin list==>>>>", error.message);
    }
  };

  const setPropertyPrice = (item) => {
    const isRent = item?.propertyType?.name.includes("Rent");
    if (isRent) {
      if (item?.priceDaily) {
        return helper.priceFormat(item?.priceDaily) + " " + config?.currency;
      } else if (item?.priceWeekly) {
        return helper.priceFormat(item?.priceWeekly) + " " + config?.currency;
      } else if (item?.priceMonthly) {
        return helper.priceFormat(item?.priceMonthly) + " " + config?.currency;
      } else if (item?.priceYearly) {
        return helper.priceFormat(item?.priceYearly) + " " + config?.currency;
      } else {
        return "N/A";
      }
    } else if (item?.price) {
      return helper.priceFormat(item?.price) + " " + config?.currency;
    } else {
      return "N/A";
    }
  };

  const selectHandler = (data) => {
    const isExists = selectedProperty?.find((res) => res?._id === data?._id);
    if (!isExists) {
      setSelectedProperty([...selectedProperty, data]);
    } else {
      setSelectedProperty(
        selectedProperty.filter((item) => item?._id !== data?._id)
      );
    }
  };

  useEffect(() => {
    if (selectedProperty?.length !== list?.length) {
      setSelectAllCheck(false);
    }
  }, [selectedProperty]);

  useEffect(() => {
    setPresentationUrl("");
  }, [showAddModal]);

  const selctAllHandler = () => {
    setSelectAllCheck(!selctAllCheck);
    if (selectedProperty?.length === list?.length) {
      setSelectedProperty([]);
    } else setSelectedProperty(list?.map((res) => res));
  };

  // console.log("selectedProperty", selectedProperty);

  const addProposal = async () => {
    if (!selectedProperty?.length) {
      notification.error(t("PLEASE_ENTER_AT_LEAST_ONE_PROPERTY"));
      return;
    }
    setAddModal(!showAddModal);
  };

  const replaceUrl = (data) => {
    if (data) {
      const dbUrl = data?.split(config?.country === "Saudi" ? "o/" : "net/");
      data = dbUrl[1];
      return data;
    }
  };

  const createProposalHandler = async () => {
    try {
      if (!customerName) {
        notification.error("Please enter customer name");
        return;
      }
      let payload = [];
      selectedProperty?.forEach((element, i) => {
        let upadtedData = {};

        if (element?.isChangeAgent) {
          upadtedData = {
            propertiesId: element?._id,
            name: element?.agent?.firstName,
            email: element?.agent?.email,
            phone: element?.agent?.phone,
            designation: element?.agent?.designation,
            image: replaceUrl(element?.agent?.image),
          };
        } else {
          upadtedData = {
            propertiesId: element?._id,
            agentId: element?.agentId,
          };
        }
        payload.push(upadtedData);
      });
      // console.log("payload",payload);
      // return
      const path = apiPath.propertiesPromotions;
      const result = await apiPost(path, { properties: payload, customerName });
      if (result?.status === 200) {
        notification.success(result.data.message);
        setPresentationUrl(result?.data?.results?.url);
        fetchProperties();
        // setAddModal(false);
        // setSelectedProperty([]);
      }
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };

  const selctChangeAgentHandler = (data) => {
    setSelectedPropertyAgent(data);
    setChangeAgentModal(!changeAgentModal);
  };

  const onSubmit = async (data) => {
    if (!profilePic) {
      notification.error(t("SELECT_IMAGE"));
      return;
    }
    setSelectedPropertyAgent([]);
    setValue("firstName", "");
    setValue("email", "");
    setValue("phone", "");
    setValue("designation", "");
    setValue("image", "");
    setProfilePic(null);

    setSelectedProperty(
      selectedProperty?.map((res) => {
        if (res?._id === selectedPropertyAgent?._id) {
          return {
            ...res,
            ...{ agent: { ...data, image: profilePic }, isChangeAgent: true },
          };
        } else return { ...res };
      })
    );
    setChangeAgentModal(false);
    setProfilePic(null);
  };

  const uploadTemporaryPhotos = async (e) => {
    const formData = new FormData();
    formData.append("image", e);
    const { data: response } = await apiPost(
      apiPath.uploadTemporaryPhotos,
      formData
    );
    if (response.success) {
      setProfilePic(response?.results?.image);
    } else {
      notification.error(response?.message);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("✅ Copied successfully ");
    } catch (e) {
      console.log("❌ Failed to copy (insufficient permissions) ");
    }
  };

  return (
    <>
      <div className="p-3">
        <div className="flex items-center">
          <button
            onClick={() => addProposal()}
            type="button"
            class="bg-[#8FC150] text-sm px-8 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2"
          >
            + {t("CREATE_PROPERTY_PROPOSAL")}
          </button>
        </div>

        <div className="overflow-x-auto relative 
 border">
          <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  <input
                    type="checkbox"
                    id="check"
                    name="selectAll"
                    checked={selctAllCheck}
                    onChange={() => selctAllHandler()}
                  />
                </th>
                <th scope="col" className="py-3 px-6">
                  #
                </th>

                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (sort.sortKey === "title" && sort.sortType === "asc") {
                      setSort({
                        sortKey: "title",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "title",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_PROPERTY_NAME")}</span>
                    <span>
                      {sort.sortKey === "title" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "title" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                {/* <th scope='col' className='py-3 px-6 text-center'>
                {t('O_NAME') + t('O_ARABIC')}
              </th> */}
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "propertyId" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "propertyId",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "propertyId",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_PROPERTY_ID")} </span>
                    <span>
                      {sort.sortKey === "propertyId" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "propertyId" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                {/* <th
                scope='col'
                className='py-3 px-6 cursor-pointer'
                onClick={() => {
                  if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                    setSort({
                      sortKey: 'name',
                      sortType: 'desc'
                    })
                  } else {
                    setSort({
                      sortKey: 'name',
                      sortType: 'asc'
                    })
                  }
                }}
              >
                <div className='flex'>
                  <span>{t('O_PROPERTY_CATEGORY')} </span>
                  <span>
                    {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th> */}
                <th
                  scope="col"
                  className="py-3 px-6  "
                  // onClick={() => {
                  //   if (
                  //     sort.sortKey === 'property_type' &&
                  //     sort.sortType === 'asc'
                  //   ) {
                  //     setSort({
                  //       sortKey: 'property_type',
                  //       sortType: 'desc'
                  //     })
                  //   } else {
                  //     setSort({
                  //       sortKey: 'property_type',
                  //       sortType: 'asc'
                  //     })
                  //   }
                  // }}
                >
                  <div className="flex">
                    <span>{t("O_PROPERTY_TYPE")} </span>
                    {/* <span>
                    {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span> */}
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "firstName" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "firstName",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "firstName",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_AGENT_NAME")} </span>
                    <span>
                      {sort.sortKey === "firstName" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "firstName" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6 ">
                  <div className="flex">
                    <span>{t("COMPANY_NAME")} </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (sort.sortKey === "price" && sort.sortType === "asc") {
                      setSort({
                        sortKey: "price",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "price",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("PRICE")} </span>
                    <span>
                      {sort.sortKey === "price" && sort.sortType === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                      {sort.sortKey === "price" && sort.sortType === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "propertySize" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "propertySize",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "propertySize",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_PROPERTY_SIZE")} </span>
                    <span>
                      {sort.sortKey === "propertySize" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "propertySize" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "threeSixtyView" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "threeSixtyView",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "threeSixtyView",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_360_VIEW")} </span>
                    <span>
                      {sort.sortKey === "threeSixtyView" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "threeSixtyView" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("Approved status")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("O_STATUS")}
                </th>
                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (
                      sort.sortKey === "listedOn" &&
                      sort.sortType === "asc"
                    ) {
                      setSort({
                        sortKey: "listedOn",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortKey: "listedOn",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex">
                    <span>{t("O_CREATED_AT")}</span>
                    <span>
                      {sort.sortKey === "listedOn" &&
                        sort.sortType === "asc" && (
                          <BsArrowUpShort className="w-4 h-4" />
                        )}
                      {sort.sortKey === "listedOn" &&
                        sort.sortType === "desc" && (
                          <BsArrowUpShort className="w-4 h-4 rotate-180" />
                        )}
                    </span>
                  </div>
                </th>

                {(manager?.add || user?.role === "admin") && (
                  <th scope="col" className="py-3 px-6">
                    {t("O_SHOW_HOME")}
                  </th>
                )}
                {(manager?.add || user?.role === "admin") && (
                  <th scope="col" className="py-3 px-6 text-center">
                    {t("O_ACTIVE_DE_ACTIVE")}
                  </th>
                )}
                {(manager?.add || user?.role === "admin") && (
                  <th scope="col" className="py-3 px-6">
                    Sold
                  </th>
                )}
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list?.map((item, i) => (
                  <tr
                    key={i}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                  >
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      <input
                        type="checkbox"
                        id="check"
                        name="property"
                        value={item?._id}
                        checked={selectedProperty.find(
                          (res) => res?._id === item?._id
                        )}
                        onChange={() => selectHandler(item)}
                      />
                    </th>
                    <th
                      scope="row"
                      className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                    >
                      {i + 1 + 10 * (paginationObj?.page - 1)}
                    </th>
                    <td className="py-2 px-2 border-r text-DarkBlue">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={`${process.env.REACT_APP_WEBSITE_BASE_URL}/property/${item?.slug}`}
                      >
                        {item?.title}
                      </a>
                    </td>
                    {/* <td className='py-2 px-2 border-r'>{item?.titleAr}</td> */}
                    <td className="py-2 px-2 border-r">{item?.propertyId}</td>
                    {/* <td className='py-2 px-2 border-r'>
                    {item?.propertyCategory?.name}
                  </td> */}
                    <td className="py-2 px-2 border-r">
                      {item?.propertyType?.name}
                    </td>
                    <td className="py-2 px-2 border-r">{`${item?.agent?.firstName} ${item?.agent?.lastName}`}</td>
                    <td className="py-2 px-2 border-r">
                      {item?.addedBy === "company"
                        ? item?.company?.name
                        : item?.addedBy === "freelancer"
                        ? "Freelancer"
                        : "Mada Properties"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {setPropertyPrice(item)}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.propertySize
                        ? item?.propertySize + " " + config?.areaUnit
                        : "N/A"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {!isEmpty(item?.threeSixtyView) && (
                        <a
                          href={item?.threeSixtyView}
                          target="_blank"
                          rel="noreferrer"
                        >
                          View
                        </a>
                      )}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.isApprovedStatus}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {item?.isSold
                        ? "Sold (" + helper.dateFormat(item?.soldDate) + ")"
                        : "Not Sold"}
                    </td>
                    <td className="py-2 px-2 border-r">
                      {helper.dateFormat(item?.listedOn)}
                    </td>
                    {(manager?.add || user?.role === "admin") && (
                      <td className="py-2 px-2 border-r text-center">
                        <label
                          className={`inline-flex relative items-center cursor-pointer`}
                        >
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={item?.isFeatured === true}
                            // disabled={
                            //   item?.propertyType?.slug === "commercial-rent"
                            // }
                            onChange={(e) =>
                              helper.alertFunction(
                                `Are you sure want to ${
                                  e.target.checked ? "active" : "inactive"
                                } show home ${item.title}?`,
                                item,
                                handelFeatureStatusChange
                              )
                            }
                          />
                          <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                        </label>
                      </td>
                    )}
                    {(manager?.add || user?.role === "admin") && (
                      <td className="py-2 px-2 border-r text-center">
                        <label
                          className="inline-flex relative items-center cursor-pointer"
                          title={`${
                            item?.status === "active" ? "Active" : "Inactive"
                          }`}
                        >
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={item?.status === "active"}
                            disabled={item?.isSold}
                            onChange={(e) =>
                              helper.alertFunction(
                                `Are you sure want to ${
                                  e.target.checked ? "active" : "inactive"
                                } ${item.title}?`,
                                item,
                                handelStatusChange
                              )
                            }
                          />
                          <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                        </label>
                      </td>
                    )}
                    {(manager?.add || user?.role === "admin") && (
                      <td className="py-2 px-2 border-r text-center">
                        {/* <label className='inline-flex relative items-center cursor-pointer' title={`${item?.isSold ? 'Active' : 'Inactive'}`}>
                        {
                          item.isSold && <span className='text-red-500'>{"Sold"}</span>
                        }
                        {
                          !item.isSold && <button className='text-Dar'>Mark Sold</button>
                        }
                        <input
                          type='checkbox'
                          className='sr-only peer'
                          checked={item?.isSold}
                          onChange={e =>
                            helper.alertFunction(
                              `Are you sure want to ${e.target.checked ? 'active' : 'inactive'
                              } ${item.title}`,
                              item,
                              handelSoldChange
                            )}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label> */}
                        {item.isSold && (
                          <span className="text-red-500">{t("SOLD")}</span>
                        )}
                        {!item.isSold && (
                          <button
                            // className='text-Dar'
                            className="animate-bounce text-lg border border-transparent text-green-600 hover:text-green-900"
                            onClick={(e) =>
                              helper.alertFunction(
                                "Are you sure to mark sold, this will be irreversible action?",
                                item,
                                handelSoldChange
                              )
                            }
                          >
                            {/* Mark Sold */}
                            <BsHandThumbsUp title="Mark Sold" />
                          </button>
                        )}
                      </td>
                    )}
                    <td className="py-2 px-2 border-l">
                      <div className="">
                        <ul className="flex justify-center">
                          <li className="px-1 py-1 hover:bg-white hover:text-LightBlue">
                            {/* <NavLink to={`/properties/view/${item._id}`} state={{ item }}>
                            <AiFillEye className='cursor-pointer w-5 h-5 text-slate-600' />
                          </NavLink> */}
                            <NavLink
                              to={`/properties/view/${item._id}`}
                              title={t("VIEW")}
                              state={{ item, propertyId: item?._id }}
                            >
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />
                            </NavLink>
                          </li>
                          {(manager?.add || user?.role === "admin") &&
                            !item.isSold && (
                              <li className="px-1 py-1 hover:bg-white hover:text-LightBlue">
                                {/*item?.fromThirdParty ? (
                                  <Link
                                    title={t("O_EDIT_PROPERTY")}
                                    // to={'/edit-property/' + item._id}
                                  >
                                    <AiFillEdit
                                      title="You can not edit the property added from third party API."
                                      className="cursor-pointer-disabled w-5 h-5 text-slate-600"
                                    />
                                  </Link>
                                ) : (
                                  <Link
                                    title={t("O_EDIT_PROPERTY")}
                                    to={"/properties/edit-property/" + item._id}
                                  >
                                    <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                                  </Link>
                                ) */}
                                {
                                  <Link
                                    title={t("O_EDIT_PROPERTY")}
                                    to={"/properties/edit-property/" + item._id}
                                  >
                                    <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                                  </Link>
                                }
                              </li>
                            )}
                          {(manager?.delete || user?.role === "admin") &&
                            !item.isSold && (
                              <li
                                title={t("O_DELETE")}
                                className="px-1 py-1 hover:bg-white hover:text-LightBlue"
                                onClick={() =>
                                  helper.alertFunction(
                                    `Are you sure want to delete ${item.title}?`,
                                    item,
                                    deleteProperty
                                  )
                                }
                              >
                                <AiFillDelete className="cursor-pointer w-5 h-5 text-slate-600" />
                              </li>
                            )}
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              {isEmpty(list) && (
                <tr className="bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6" colSpan={16}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showAddModal && (
        <div className="modal">
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6  w-full max-w-[1150px] mx-auto">
              <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl font-semibold">
                      {t("CREATE_PROPERTY_PROPOSAL")}
                    </h3>
                    <button
                      className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                      onClick={() => {
                        setCustomerName("");
                        setSelectedProperty([]);
                        setPresentationUrl(false);
                        setAddModal(!showAddModal);
                      }}
                    >
                      <span
                        className=" text-[#B8BBBF]  text-4xl "
                        title="Close"
                      >
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="m-3">
                    <TextField
                      fullWidth
                      size="small"
                      label="Customer Name"
                      type="text"
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                    />
                  </div>
                  <div className="overflow-x-auto relative 
 border m-3">
                    <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                      <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                          <th scope="col" className="py-3 px-6">
                            <div className="flex">
                              <span>{t("O_PROPERTY_NAME")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_PROPERTY_ID")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6  ">
                            <div className="flex">
                              <span>{t("O_PROPERTY_TYPE")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_AGENT_NAME")} </span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("PRICE")} </span>
                            </div>
                          </th>

                          <th scope="col" className="py-3 px-6 cursor-pointer">
                            <div className="flex">
                              <span>{t("O_PROPERTY_SIZE")} </span>
                            </div>
                          </th>
                          <th scope="col" className="py-3 px-6 text-center">
                            {t("CHANGE_AGENT")}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedProperty &&
                          selectedProperty?.map((item) => {
                            return (
                              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                                <th
                                  key={item?._id}
                                  scope="row"
                                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                                >
                                  {item?.title}
                                </th>
                                <td className="py-2 px-2 border-r">
                                  {item?.propertyId}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {item?.propertyType?.name}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {`${item?.agent?.firstName} ${
                                    item?.agent?.lastName
                                      ? item?.agent?.lastName
                                      : ""
                                  }`}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {setPropertyPrice(item)}
                                </td>
                                <td className="py-2 px-2 border-r">
                                  {item?.propertySize
                                    ? item?.propertySize +
                                      " " +
                                      config?.areaUnit
                                    : "N/A"}
                                </td>
                                <th scope="col" className="py-3 px-6">
                                  <input
                                    type="checkbox"
                                    id="change-agent"
                                    name="change-agent"
                                    value={item?._id}
                                    checked={
                                      selectedPropertyAgent?.length &&
                                      selectedPropertyAgent?.find(
                                        (res) => res?._id === item?._id
                                      )
                                    }
                                    onChange={() =>
                                      selctChangeAgentHandler(item)
                                    }
                                  />
                                </th>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {presentationUrl && (
                    <div className="flex items-center justify-between p-5 rounded-t">
                      <p className="text-s font-semibold">
                        Property presentation link:
                        <Link
                          to={presentationUrl}
                          target="_blank"
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            fontSize: 14,
                          }}
                        >
                          {`${presentationUrl}`}
                        </Link>
                      </p>
                      <div className="col-2 text-center ml-5">
                        <OButton
                          label={<>{t("COPY_URL")} </>}
                          type="button"
                          onClick={() => copyToClipboard(presentationUrl)}
                        />
                      </div>
                    </div>
                  )}

                  {!presentationUrl && (
                    <div className="col-2 text-center mb-5">
                      <OButton
                        label={<>{t("CREATE")} </>}
                        type="button"
                        onClick={() => createProposalHandler()}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </div>
      )}

      {changeAgentModal && (
        <div className="modal">
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative my-6  w-full max-w-[1150px] mx-auto">
              <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl font-semibold">
                      {t("CHANGE_AGENT")}
                    </h3>
                    <button
                      className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                      onClick={() => setChangeAgentModal(!changeAgentModal)}
                    >
                      <span
                        className=" text-[#B8BBBF]  text-4xl "
                        title="Close"
                      >
                        ×
                      </span>
                    </button>
                  </div>

                  <div className="overflow-x-auto relative 
 border m-3">
                    <div className="grid grid-rows-1 grid-cols-2 gap-4 p-3">
                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="firstName"
                          inputLabel={<>{t("O_FULL_NAME")}</>}
                          type="text"
                          autoFocus
                          register={register("firstName", {
                            required: "Please enter name",
                          })}
                          errors={errors}
                        />
                      </div>
                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="email"
                          inputLabel={<>{t("LOGIN_EMAIL")}</>}
                          type="text"
                          autoFocus
                          register={register("email", {
                            required: "Please enter email",
                          })}
                          errors={errors}
                        />
                      </div>

                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="phone"
                          inputLabel={<>{t("PHONE")}</>}
                          type="text"
                          autoFocus
                          register={register("phone", {
                            required: "Please enter phone",
                          })}
                          errors={errors}
                        />
                      </div>
                      <div className="flex flex-col text-sm rounded-md">
                        <OInputField
                          wrapperClassName=""
                          name="designation"
                          inputLabel={<>{t("AGENT_DESIGNATION")}</>}
                          type="text"
                          autoFocus
                          register={register("designation", {
                            required: "Please enter designation",
                          })}
                          errors={errors}
                        />
                      </div>

                      <div className="flex flex-col text-sm rounded-md">
                        <span className="flex align-center">
                          {t("UPLOAD_PROFILE_PICTURE")}
                        </span>
                        <input
                          type="file"
                          accept="image/png, image/jpg, image/jpeg"
                          name="profilePic"
                          onChange={(e) =>
                            uploadTemporaryPhotos(e?.target?.files[0])
                          }
                        />

                        {profilePic && (
                          <OImage
                            src={
                              profilePic
                              // ? URL.createObjectURL(profilePic)
                              // : ''
                            }
                            fallbackUrl="/images/user.png"
                            className="w-24 h-24 m-auto"
                            alt=""
                            style={{ borderRadius: "50%" }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-2 text-center mb-5">
                    <OButton
                      label={<>{t("O_ADD")}</>}
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </div>
      )}
    </>
  );
};

export default List;
